module.exports = __webpack_public_path__ + "fonts/CrimsonText-Bold.060a8117.ttf";